import { render, staticRenderFns } from "./Paginate.vue?vue&type=template&id=322047af&scoped=true&"
import script from "./Paginate.vue?vue&type=script&lang=js&"
export * from "./Paginate.vue?vue&type=script&lang=js&"
import style0 from "./Paginate.vue?vue&type=style&index=0&id=322047af&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "322047af",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('322047af')) {
      api.createRecord('322047af', component.options)
    } else {
      api.reload('322047af', component.options)
    }
    module.hot.accept("./Paginate.vue?vue&type=template&id=322047af&scoped=true&", function () {
      api.rerender('322047af', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2cbEzrgD61qU5/JS/comp/Paginate.vue"
export default component.exports